/**
 * @readonly
 * @enum {String}
 */
const tournamentTypesEnum = {
    regular: 'regular',
    turbo: 'turbo',
    superturbo: 'superturbo',
}

const defaultTournamentType = tournamentTypesEnum.regular;

export {
    tournamentTypesEnum,
    defaultTournamentType
}
